(function() {
	'use strict';

/* -- Tools -- */

	function analytics(action, label='null') {
		window.dataLayer.push({
			'event': 'Interactive',
			'category': 'Interactive',
			'action': action,
			'label': label
		});
		// console.clear();
		// console.table(window.dataLayer);
	}

	// function throttle(callback, limit) {
	// 	var wait = false;
	// 	return function() {
	// 		if (wait) return;
	// 		callback.call();
	// 		wait = true;
	// 		setTimeout(function(){
	// 			wait = false;
	// 		}, limit);
	// 	}
	// }

/* -- Function -- */

	function closeInfo() {
		// Get the currently open information
		const open = document.querySelector('.ml__info--active');

		// if it exist we close it
		if (open) open.classList.remove('ml__info--active');
	}

	function openInfo(name) {
		// Get the proper information
		const info = document.querySelector('.ml__info--' + name);

		// And open it
		if (info) info.classList.add('ml__info--active');
	}

	function closeMarker() {
		// Get the currently open marker
		const open = document.querySelector('.ml__button--active');

		// if it exist we close it
		if (open) open.classList.remove('ml__button--active');
	}

	function openMarker(name) {
		// Get the proper marker
		const marker = document.querySelector('.ml__button[value="' + name + '"]');

		// And open it
		if (marker) marker.classList.add('ml__button--active');
	}

	function addDropdown() {
		// Create the select
		const select = document.createElement('select');
		select.className = 'ml__select';

		// Get all the value that are needed
		const markers = [].slice.call(document.querySelectorAll('.ml__button'));
		let values = markers.map(x => [x.value, x.textContent]);

		// Add the first element title
		values.unshift(['none', 'Please select location..']);

		// Create the options and add them to the select
		let options = '';
		values.forEach(function(value){
			options += `<option class="ml__option" value="${value[0]}">${value[1]}</option>`;
		});
		select.innerHTML = options;

		// Add the select to the container
		const container = document.querySelector('.ml__container');
		const map = document.querySelector('.ml__wrapper');
		container.insertBefore(select, map);
	}

/* -- Application -- */

	function app() {

		// Get the container
		const container = document.querySelector('.ml__container');

		// Create the dropdown list
		addDropdown();

		// Here we go for the clicks
		container.addEventListener('click', function(event){

			// Check if its a marker we are looking at
			if (event.target.classList.contains('ml__button')){
				closeInfo();
				closeMarker();

				// Get the name of the marker
				const name = event.target.value;

				// Open the appropriate information
				openInfo(name);
				openMarker(name);

				// Send analytics
				analytics('click', name);
			}

			// If it's close button or if it's the map
			if (
				event.target.classList.contains('ml__info__close') ||
				event.target.classList.contains('ml__map')
			){
				closeInfo();
				closeMarker();
				document.querySelector('.ml__select').selectedIndex = 0;
			}

		});

		// Here we go for the clicks
		container.addEventListener('change', function(event){

			// Check if its a dropdown
			if (event.target.classList.contains('ml__select')){
				closeInfo();

				// Get the name of the marker
				const name = event.target.value;
				if (name !== 'none'){

					// Open the appropriate information
					openInfo(name);

					// Send analytics
					analytics('click', name);

				} else {
					closeInfo();
				}
			}
		});
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener('readystatechange', function() {
		document.readyState === 'interactive' && app();
	}, false);

// end of the interactive
})();
